import IInitializeSessionVM from '../view_modals/IInitializeSessionVM.ts';
import APIAxios from '../APIAxios.ts';

const initializeScoringSession = async (vm: IInitializeSessionVM) => {
    try {
      const response = await APIAxios.post('/Session/InitializeScoringSession', vm);
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };

  const initializeVotingSession = async (vm: IInitializeSessionVM) => {
    try {
      const response = await APIAxios.post('/Session/InitializeVotingSession', vm);
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };


  const getTeams = async (sessionId) => {
    try {
      const response = await APIAxios.get(`/Session/GetTeams/${sessionId}`);
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };

  const getTeam = async (sessionId, teamId) => {
    try {
      const response = await APIAxios.get(`/Session/GetTeam/${sessionId}/${teamId}`);
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };

  const getUsers = async(sessionId) => {
    try{
      const response = await APIAxios.get(`/Session/GetUsers/${sessionId}`);
      const data = response.data;
      return data;
    } catch(err){
      throw err;
    }
  }

  const getLeaderboard = async(sessionId) => {
    try{
      const response = await APIAxios.get(`/Session/GetLeaderboard/${sessionId}`);
      const data = response.data;
      return data;
    } catch(err){
      throw err;
    }
  }


  const sessionService = {
    initializeScoringSession,
    initializeVotingSession,
    getTeams,
    getTeam,
    getUsers,
    getLeaderboard
  };
  
  export default sessionService;